import {t} from "@lingui/core/macro";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {getMasteryDisplay} from "@khan/mastery";

import type {
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions as ActivitySessionsReportRow,
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions_MasteryActivitySession_skillLevels as SkillLevelChange,
} from "./__graphql-types__/ActivitySessionsV2Query.ts";
import {DefaultNotApplicable} from "./change-indicator.tsx";

interface Props {
    activitySessionsReportRow: ActivitySessionsReportRow;
    changes?: Array<SkillLevelChange | null | undefined> | null | undefined;
    onShowDetails: (row: ActivitySessionsReportRow) => void;
}

const MasterySkillLevelCell: React.FC<Props> = ({
    activitySessionsReportRow,
    changes,
    onShowDetails,
}) => {
    if (!changes?.length) {
        return <DefaultNotApplicable />;
    }
    if (activitySessionsReportRow.skillType !== "MULTI_SKILL") {
        if (changes[0]?.after) {
            return <Body>{getMasteryDisplay(changes[0].after)}</Body>;
        }
        return <DefaultNotApplicable />;
    }
    return (
        <Button
            kind="tertiary"
            onClick={() => onShowDetails(activitySessionsReportRow)}
        >
            {t`Details`}
        </Button>
    );
};

export default MasterySkillLevelCell;
